const imagePostFunction = (image, src) => {
	const img = image.getImage();
	if (typeof window.btoa === 'function') {
		const xhr = new XMLHttpRequest();
		const dataEntries = src.split('&');
		let url;
		let params = '';
		for (let i = 0; i < dataEntries.length; i++) {
			if (i === 0) {
				url = dataEntries[i];
			} else {
				params = params + '&' + dataEntries[i];
			}
		}
		xhr.open('POST', url, true);
		xhr.responseType = 'arraybuffer';
		xhr.onload = function (e) {
			if (xhr.status === 200) {
				const uInt8Array = new Uint8Array(xhr.response);
				let i = uInt8Array.length;
				const binaryString = new Array(i);
				while (i--) {
					binaryString[i] = String.fromCharCode(uInt8Array[i]);
				}
				const data = binaryString.join('');
				const type = xhr.getResponseHeader('content-type');
				if (type.indexOf('image') === 0) {
					img.src = 'data:' + type + ';base64,' + window.btoa(data);
				}
			}
		};
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		xhr.send(params);
	} else {
		img.src = src;
	}
};

export { imagePostFunction };